import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getThisYearCourses() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}this-year-courses`);
    return response.data

  } catch (error) {
    console.error('Error al obtener los cursos', error);
  }
}